import { useState, useMemo, useEffect } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

// ─── CONTRASEÑA — cambiala cuando quieras ─────────────────────────────────
const ACCESS_USER = "CNAsesores";
const ACCESS_PASS = "cnoutbound26";

// ─── DATA PERETTI ──────────────────────────────────────────────────────────
const HOGAR_SIN_AUTO_PERETTI = [
  { nombre: "KEVIN PEDREIRA ADRIAN", prima: 591024, otros_ramos: [] },
  { nombre: "FRANCO PERETTI", prima: 579314, otros_ramos: [] },
  { nombre: "ERNESTO BLAZINSEK", prima: 360052, otros_ramos: [] },
  { nombre: "ALFONSO YACOY JESUS", prima: 241766, otros_ramos: [] },
  { nombre: "VERONICA SCOLA PAULA", prima: 140824, otros_ramos: [] },
  { nombre: "NANCY FERNANDEZ MABEL", prima: 86750, otros_ramos: [] },
  { nombre: "TOMAS BALBUENA", prima: 67444, otros_ramos: [] },
  { nombre: "JORGE GAUNA ROBOTTI EDUARDO", prima: 64931, otros_ramos: [] },
  { nombre: "RAMIRO GRAZIANO", prima: 59602, otros_ramos: [] },
  { nombre: "MARIEL DORADO INES", prima: 58453, otros_ramos: [] },
  { nombre: "MARILYN PERONE", prima: 55370, otros_ramos: [] },
  { nombre: "CARLA PIRAGINE MARIELA", prima: 49151, otros_ramos: [] },
  { nombre: "JULIO BURATTI CESAR", prima: 46500, otros_ramos: [] },
  { nombre: "NESTOR ARDILA BELTRAN WILSON", prima: 44568, otros_ramos: [] },
  { nombre: "LILIANA OZEJOWSKY BEATRIZ", prima: 31212, otros_ramos: [] },
  { nombre: "ELIANA FUENTE SOLEDAD", prima: 28621, otros_ramos: [] },
  { nombre: "VICTORIA PEREZ SOFIA", prima: 26222, otros_ramos: [] },
  { nombre: "CAROLINA CAMPOS SOLEDAD", prima: 24819, otros_ramos: [] },
  { nombre: "IVAN ZARZA THOMAS", prima: 24295, otros_ramos: [] },
  { nombre: "JOSE RUIZ IGNACIO", prima: 21114, otros_ramos: [] },
  { nombre: "FEDERICO LENTINI CARLOS ALBERTO", prima: 15518, otros_ramos: [] },
  { nombre: "BRUNO ROMERO", prima: 14863, otros_ramos: [] },
  { nombre: "CARLOS LICANTICA PABLO DE JESUS", prima: 13440, otros_ramos: [] },
];
const AUTO_SIN_HOGAR_PERETTI = [
  { nombre: "JESICA GRISEL UMEREZ", prima: 1641923, otros_ramos: [] },
  { nombre: "NORMA BEATRIZ FERNANDEZ", prima: 1599793, otros_ramos: [] },
  { nombre: "NICOLAS AGUSTIN VELAZQUEZ", prima: 1413641, otros_ramos: [] },
  { nombre: "ELISABET ALVAREZ", prima: 1332049, otros_ramos: [] },
  { nombre: "MELINA LUJAN GONZALEZ", prima: 1305583, otros_ramos: [] },
  { nombre: "MARIELA BEATRIZ SCHENFELD", prima: 1180487, otros_ramos: [] },
  { nombre: "MIRTA ELIZABETH CALISAYA", prima: 1173444, otros_ramos: [] },
  { nombre: "MILENA PASSERINI", prima: 1160806, otros_ramos: [] },
  { nombre: "LAURA ANDREA SOMOZA", prima: 1142137, otros_ramos: [] },
  { nombre: "LUIS CESAR PEREYRA", prima: 1098558, otros_ramos: [] },
  { nombre: "GABRIEL ESTEBAN RAMOS PALADEA", prima: 1084815, otros_ramos: [] },
  { nombre: "VIVIANA MABEL MOLINA", prima: 1069589, otros_ramos: [] },
  { nombre: "RAMON JAVIER DUARTE", prima: 1019845, otros_ramos: [] },
  { nombre: "GLADYS ESTER OLIVERA", prima: 1018625, otros_ramos: [] },
  { nombre: "MARIA INES CENTURION", prima: 981723, otros_ramos: [] },
  { nombre: "MIRIAN MABEL ANDRADE", prima: 960367, otros_ramos: [] },
  { nombre: "MARIELA NANCY TABAREZ", prima: 955864, otros_ramos: [] },
  { nombre: "JAVIER MARTIN MOLINA", prima: 953760, otros_ramos: [] },
  { nombre: "JUAN CARLOS COQUI", prima: 942370, otros_ramos: [] },
  { nombre: "SANDRO DINO CESPEDES", prima: 915579, otros_ramos: [] },
  { nombre: "MARIA VICTORIA URIARTE", prima: 914745, otros_ramos: [] },
  { nombre: "VIDAL CLARES HUANCA", prima: 892923, otros_ramos: [] },
  { nombre: "ROCIO MARIBEL COIMBRA", prima: 881353, otros_ramos: [] },
  { nombre: "JAZMIN ABRIL BARILE", prima: 875167, otros_ramos: [] },
  { nombre: "ROQUE RAUL ESPINOSA", prima: 874339, otros_ramos: [] },
  { nombre: "SANTIAGO JUAN MUNICH", prima: 850460, otros_ramos: [] },
  { nombre: "ELIANA ANDREINA GANDICA ZAMBRANO", prima: 849376, otros_ramos: [] },
  { nombre: "JOSEFINA MAKAR", prima: 841292, otros_ramos: [] },
  { nombre: "LUIS OMAR APELT", prima: 836456, otros_ramos: [] },
  { nombre: "JUAN ALEJANDRO BUASSO", prima: 818995, otros_ramos: [] },
  { nombre: "FLAVIA LORENA GODINO", prima: 778389, otros_ramos: [] },
  { nombre: "LAURA ANDREA PONCE", prima: 776967, otros_ramos: [] },
  { nombre: "BRISA NAIARA DUARTE", prima: 750967, otros_ramos: [] },
  { nombre: "RICARDO DANIEL PASSERINI", prima: 747269, otros_ramos: [] },
  { nombre: "AGUSTIN NICOLAS AUDANO", prima: 723601, otros_ramos: [] },
  { nombre: "NOELIA ANDREA BELFIORE", prima: 723610, otros_ramos: [] },
  { nombre: "JAIRO JOSE VARGAS RODRIGUEZ", prima: 722824, otros_ramos: [] },
  { nombre: "SANTIAGO PABLO FEDELE", prima: 710603, otros_ramos: [] },
  { nombre: "MARIA LAURA AGUIRRE", prima: 705621, otros_ramos: [] },
  { nombre: "GALVIS MARCOS JOSE SAEZ", prima: 657963, otros_ramos: [] },
  { nombre: "LUIS FERNANDO ALVAREZ MALDONADO", prima: 657464, otros_ramos: [] },
  { nombre: "LUIS HORACIO BRITO HERRERA", prima: 648540, otros_ramos: [] },
  { nombre: "PAOLO SEBASTIAN GONZALEZ", prima: 648394, otros_ramos: [] },
  { nombre: "HORACIO ENRIQUE IGLESIAS", prima: 632988, otros_ramos: [] },
  { nombre: "HERNAN GLUSTEIN", prima: 626641, otros_ramos: [] },
  { nombre: "VANINA CARLA ACAMPORA", prima: 589068, otros_ramos: [] },
  { nombre: "JOHANA MARICEL CARABALLO", prima: 566277, otros_ramos: [] },
  { nombre: "MARIA VICTORIA KON", prima: 551600, otros_ramos: [] },
  { nombre: "JORGE EDUARDO SUAREZ", prima: 535161, otros_ramos: [] },
  { nombre: "JUAN CARLOS CASTRO", prima: 534618, otros_ramos: [] },
  { nombre: "ANTONIO ORESTE DELUCA", prima: 534259, otros_ramos: [] },
  { nombre: "VANESA ANABELA COLL", prima: 524383, otros_ramos: [] },
  { nombre: "ENRIQUE ALEJANDRO ISTURIZ", prima: 522184, otros_ramos: [] },
  { nombre: "GRACIELA NOEMI PENA", prima: 492945, otros_ramos: [] },
  { nombre: "MIRIAM PATRICIA CAVALIERI", prima: 478597, otros_ramos: [] },
  { nombre: "CARLOS ELIAS SANJUAN", prima: 476271, otros_ramos: [] },
  { nombre: "FEDERICO ADRIAN PERISSE", prima: 416814, otros_ramos: [] },
  { nombre: "ROCIO ISABEL MASSARONE", prima: 413844, otros_ramos: [] },
  { nombre: "ANA MARIA MAKAR", prima: 406350, otros_ramos: [] },
  { nombre: "ALEJANDRO ATILIO CATALANO", prima: 395448, otros_ramos: [] },
  { nombre: "MARIO FECHA REINALDO", prima: 355345, otros_ramos: [] },
  { nombre: "TATIANA DIAZ", prima: 354712, otros_ramos: [] },
  { nombre: "ESTEBAN GASTON ROBIN", prima: 349521, otros_ramos: [] },
  { nombre: "JESICA WIRTH", prima: 333579, otros_ramos: [] },
  { nombre: "HECTOR HORACIO CCAMPODONICO", prima: 298709, otros_ramos: [] },
  { nombre: "SEBASTIAN ARIEL ACAMPORA", prima: 283992, otros_ramos: [] },
  { nombre: "ANA MARIA DUARTE", prima: 269116, otros_ramos: [] },
  { nombre: "LIZ ETHEL LUTZ", prima: 263411, otros_ramos: [] },
  { nombre: "JUAN IGNACIO RIVERO JACOBSEN", prima: 229874, otros_ramos: [] },
  { nombre: "ALEJANDRO FABIAN LENTIJO", prima: 227808, otros_ramos: [] },
  { nombre: "ALDO EMILIO LEDESMA DUARTE", prima: 194431, otros_ramos: [] },
  { nombre: "MIGUEL ANGEL GIMENEZ LOPEZ", prima: 163941, otros_ramos: [] },
  { nombre: "CLAUDIA ESTER QUINTEROS", prima: 150725, otros_ramos: [] },
  { nombre: "RAUL ANGEL CARRIZO WALTER", prima: 147704, otros_ramos: [] },
  { nombre: "MARIELA GONZALEZ", prima: 142306, otros_ramos: [] },
  { nombre: "JOSE BELISARIO CABRERA", prima: 129429, otros_ramos: [] },
  { nombre: "MARIA CECILIA SANTOS", prima: 122969, otros_ramos: [] },
  { nombre: "PEDRO BOSELLI", prima: 99245, otros_ramos: [] },
  { nombre: "JUAN JOSE CAVANAGH", prima: 88359, otros_ramos: [] },
  { nombre: "JUAN PABLO PRADA", prima: 75889, otros_ramos: [] },
  { nombre: "JORGE CLAUDIO CHERNIZKY", prima: 71967, otros_ramos: [] },
  { nombre: "MARIA CECILIA GARCIA", prima: 66083, otros_ramos: [] },
];
const MOTO_SIN_HOGAR_PERETTI = [
  { nombre: "NOELIA ANDREA BELFIORE", prima: 391373 },
  { nombre: "JAIME ADRIAN KHASKI", prima: 254612 },
  { nombre: "CARLA NADIN PEREZ", prima: 186625 },
  { nombre: "RAUL ADRIAN SBRILLER", prima: 166727 },
  { nombre: "ENRIQUE FERNANDO POZADA VERONA", prima: 148630 },
  { nombre: "SILVIA LILIANA INGLES", prima: 141096 },
  { nombre: "GUILLERMO CARLOS DINGEVAN", prima: 128357 },
  { nombre: "JUAN IGNACIO RIVERO JACOBSEN", prima: 105932 },
  { nombre: "SANDRA NOEMI CUENCA", prima: 84094 },
  { nombre: "VALENTINA SOFIA ALBORNOZ", prima: 80890 },
  { nombre: "ELISABET ALVAREZ", prima: 78173 },
  { nombre: "MATIAS LEONEL CORDOBA", prima: 73480 },
  { nombre: "PATRICIA ALDANA ESCALADA", prima: 65581 },
  { nombre: "JUAN IGNACIO CAJIGAL", prima: 63918 },
  { nombre: "MATIAS ARIEL CARRANZA", prima: 60377 },
  { nombre: "TATIANA SHANDEL ORTEGA ANTAURCO", prima: 53175 },
  { nombre: "JORGE OMAR GIMENEZ", prima: 52415 },
  { nombre: "MANUEL IGNACIO VEGA MANSILLA", prima: 39801 },
  { nombre: "ALEJANDRO ANTONIO LUJAN LOPEZ", prima: 36038 },
  { nombre: "EMANUEL IAN SILVA", prima: 32624 },
  { nombre: "SERGIO ALEJANDRO RIVERO", prima: 31583 },
  { nombre: "GABRIEL ALEJANDRO RAMIREZ", prima: 9645 },
];

// ─── DATA CN PUERTA ────────────────────────────────────────────────────────
const HOGAR_SIN_AUTO_PUERTA = [
  { nombre: "EZEQUIEL SALAS FRANCISCO", prima: 957491, otros_ramos: [] },
  { nombre: "DANIEL URTASUN JORGE", prima: 77364, otros_ramos: [] },
  { nombre: "SANTIAGO WIRTH", prima: 68694, otros_ramos: [] },
  { nombre: "MARIA KOCKAR VERONICA", prima: 64621, otros_ramos: [] },
  { nombre: "MARIA PIA GUGLIELMI DE LA FUENTE", prima: 51130, otros_ramos: [] },
  { nombre: "DANIEL VARSKY OSVALDO", prima: 55205, otros_ramos: [] },
  { nombre: "JOAQUIN BAS ALEJO", prima: 25446, otros_ramos: [] },
  { nombre: "GABRIELA GOMEZ PAULA", prima: 15565, otros_ramos: [] },
];
const AUTO_SIN_HOGAR_PUERTA = [
  { nombre: "MARIANO GUBITOSI", prima: 8942311, otros_ramos: [] },
  { nombre: "LEONARDO ALLEGRINI NAHUEL", prima: 8319785, otros_ramos: [] },
  { nombre: "RAUL ANIBAL ETCHEVERRY", prima: 4001667, otros_ramos: [] },
  { nombre: "BARMATIC VENDING SRL", prima: 3892137, otros_ramos: [] },
  { nombre: "MATIAS EZEQUIEL ARBOL", prima: 3272869, otros_ramos: [] },
  { nombre: "DARIO HORACIO BOTTE", prima: 2721225, otros_ramos: [] },
  { nombre: "NANCY BEATRIZ VACCARIELLO", prima: 2714523, otros_ramos: [] },
  { nombre: "GUSTAVO FEDERICO WITT", prima: 2619100, otros_ramos: [] },
  { nombre: "MARCELO FABIAN CARRASCO", prima: 2509735, otros_ramos: [] },
  { nombre: "ANABELLA SOLEDAD BENITEZ", prima: 2392073, otros_ramos: [] },
  { nombre: "FCG SERVICIOS SRL", prima: 2370126, otros_ramos: [] },
  { nombre: "JULIETA MERLI", prima: 2273329, otros_ramos: [] },
  { nombre: "GERARDO LUIS DELECRAZ", prima: 2081160, otros_ramos: [] },
  { nombre: "NICOLAS MARZOCCA", prima: 2068065, otros_ramos: [] },
  { nombre: "RAUL BERNARDO ETCHEVERRY", prima: 1902697, otros_ramos: [] },
  { nombre: "FELIX ROBERTO SFORZINI", prima: 1766736, otros_ramos: [] },
  { nombre: "CAROLINA YEDRO", prima: 1756556, otros_ramos: [] },
  { nombre: "GERARDO DANIEL MULLER", prima: 1749540, otros_ramos: [] },
  { nombre: "FRANCO GRAZIANO", prima: 1729914, otros_ramos: [] },
  { nombre: "GUSTAVO ANDRES CHAJCHIR", prima: 1985103, otros_ramos: [] },
  { nombre: "PABLO MARTIN CASTRO", prima: 1851712, otros_ramos: [] },
  { nombre: "MARIA FLORENCIA CARRASCO", prima: 1831852, otros_ramos: [] },
  { nombre: "JOSE LUIS PARENTE", prima: 1668530, otros_ramos: [] },
  { nombre: "GUILLERMO HORACIO ASTARITA", prima: 1664608, otros_ramos: [] },
  { nombre: "ADRIANA BEATRIZ SETOAIN", prima: 1526501, otros_ramos: [] },
  { nombre: "MARTIN GABRIEL SANCHEZ", prima: 1566322, otros_ramos: [] },
  { nombre: "MARIA LAURA SANTOS", prima: 1456643, otros_ramos: [] },
  { nombre: "CRISTIAN GABRIEL GOMEZ PASUT", prima: 1475997, otros_ramos: [] },
  { nombre: "ANDREA CECILIA COPPOLA", prima: 1432746, otros_ramos: [] },
  { nombre: "GABRIEL SANTOS CANTARINI", prima: 1420714, otros_ramos: [] },
  { nombre: "SEBASTIAN ALEJANDRO RODRIGUEZ", prima: 1369158, otros_ramos: [] },
  { nombre: "ANA EDITH LOPEZ", prima: 1354009, otros_ramos: [] },
  { nombre: "PAULA JULIETA FRANGIPANI", prima: 1333457, otros_ramos: [] },
  { nombre: "AUTOMILENIO S A", prima: 1343160, otros_ramos: [] },
  { nombre: "MARCELO DUARTE ARIEL", prima: 1145297, otros_ramos: ["Moto"] },
  { nombre: "SERGIO ADRIAN GAMBA", prima: 1158949, otros_ramos: [] },
  { nombre: "MARTIN EZEQUIEL MANGONE", prima: 1141552, otros_ramos: [] },
  { nombre: "TEXTIL SALGADO SA", prima: 1171600, otros_ramos: [] },
  { nombre: "MYRIAN LORENA IGLESIA", prima: 1127789, otros_ramos: [] },
  { nombre: "KARINA CYNTHIA FRAGALA", prima: 1106057, otros_ramos: [] },
  { nombre: "JORGE RAUL HORACIO MAZZARRON", prima: 1104468, otros_ramos: [] },
  { nombre: "FLORENCIA BELEN MAROTTA", prima: 1097893, otros_ramos: [] },
  { nombre: "HORACIO ALFREDO FERNANDEZ", prima: 1056886, otros_ramos: [] },
  { nombre: "ALEJANDRA ELENA IEZZI", prima: 1045326, otros_ramos: [] },
  { nombre: "MARCELO NICOLAS COLELLA", prima: 1043223, otros_ramos: [] },
  { nombre: "ALBERTO NAZARENO GARRIDO", prima: 1041958, otros_ramos: [] },
  { nombre: "HUGO DENIS BENITEZ", prima: 1028564, otros_ramos: [] },
  { nombre: "HORACIO GILARDI LAURO", prima: 998648, otros_ramos: [] },
  { nombre: "MIRTA GRACIELA FLORES", prima: 998857, otros_ramos: [] },
  { nombre: "INES DEL VALLE QUIROGA", prima: 973830, otros_ramos: [] },
  { nombre: "GUSTAVO FABIAN BAUMEISTER", prima: 975311, otros_ramos: [] },
  { nombre: "ESTEBAN GARCIA PADIN", prima: 901892, otros_ramos: [] },
  { nombre: "JESICA IVONNE MARCHAK", prima: 928061, otros_ramos: [] },
  { nombre: "GONZALO RAMIRO RAMOS", prima: 831854, otros_ramos: [] },
  { nombre: "PABLO ALBERTO ARIAS", prima: 806131, otros_ramos: [] },
  { nombre: "FRANCO NICOLAS LEISS", prima: 802171, otros_ramos: [] },
  { nombre: "ROBERTO ARIEL LARREA", prima: 798555, otros_ramos: [] },
  { nombre: "LORENA ELIZABETH ARAUJO", prima: 777973, otros_ramos: [] },
  { nombre: "CECILIA GABRIELA BOTTACCHI", prima: 775223, otros_ramos: [] },
  { nombre: "JOSE RODOLFO APAS", prima: 745289, otros_ramos: [] },
  { nombre: "NOEMI BEATRIZ WOLF", prima: 934655, otros_ramos: [] },
  { nombre: "NICOLAS MATIAS SANZ", prima: 753091, otros_ramos: [] },
  { nombre: "HECTOR JAVIER BENITEZ", prima: 731630, otros_ramos: [] },
  { nombre: "GUSTAVO FABIAN SZAPKIEVICH", prima: 729785, otros_ramos: [] },
  { nombre: "MARIELA ALEJANDRA GIMENEZ", prima: 726915, otros_ramos: [] },
  { nombre: "MARISA INI", prima: 687833, otros_ramos: [] },
  { nombre: "ELIANA PRISCILA BETNE", prima: 679785, otros_ramos: [] },
  { nombre: "SEBASTIAN FUKS", prima: 322487, otros_ramos: [] },
];
const MOTO_SIN_HOGAR_PUERTA = [
  { nombre: "GUSTAVO DAVID GOMEZ CEBERR", prima: 949858 },
  { nombre: "DIEGO NORBERTO BRANCA", prima: 403153 },
  { nombre: "ALAN GABRIEL MANTECON", prima: 337697 },
  { nombre: "EMILIANO MARTIN HAASE", prima: 366312 },
  { nombre: "FERNANDO DAVID MARTINEZ", prima: 353190 },
  { nombre: "FEDERICO JUAN MANOLIOS", prima: 316284 },
  { nombre: "ALEJANDRO EDUARDO VIGALONDO", prima: 323999 },
  { nombre: "WALTER ALEJANDRO TORANCIO", prima: 270211 },
  { nombre: "MARCELO ARIEL DUARTE", prima: 285661 },
  { nombre: "MARCELO ALEJANDRO MARTINEZ", prima: 283992 },
  { nombre: "LUCIANO PEDRO CANO", prima: 258118 },
  { nombre: "GUSTAVO ALEJANDRO SCAPINO", prima: 253436 },
  { nombre: "HECTOR JOSE RIVERO", prima: 222487 },
  { nombre: "ANIBAL EMANUEL RODRIGUEZ", prima: 210716 },
  { nombre: "VIVIANA SANCHEZ ROGNONE", prima: 204363 },
  { nombre: "HUGO LUCIO FLORENTIN AQUINO", prima: 127989 },
  { nombre: "FABIO NESTOR LERDA OLBERG", prima: 128168 },
  { nombre: "HERNAN GERPE", prima: 119936 },
  { nombre: "JAVIER ADRIAN SZARKO", prima: 121243 },
  { nombre: "JORGE ENRIQUE CABRERA", prima: 110705 },
  { nombre: "NICOLAS D ADDONA", prima: 68550 },
  { nombre: "ALBERTO ESEQUIEL MARTINEZ", prima: 63918 },
  { nombre: "GUIDO SCAZZIOTA", prima: 52679 },
  { nombre: "LUCA ANDRES PAOLINI", prima: 50533 },
  { nombre: "MARIANO JAVIER TILVE", prima: 46807 },
  { nombre: "MATIAS LEONEL CORDOBA", prima: 37442 },
  { nombre: "THIAGO AGUSTIN VILLANUEVA BENITEZ", prima: 31436 },
  { nombre: "JORGE LUIS MARMO", prima: 23453 },
  { nombre: "MARIA CECILIA SCARABELLO", prima: 19620 },
  { nombre: "JORGE OMAR GIMENEZ", prima: 13679 },
  { nombre: "MARIA FERNANDA LOBATO", prima: 11183 },
];

// ─── HELPERS ───────────────────────────────────────────────────────────────
const fmt         = n => new Intl.NumberFormat("es-AR", { style:"currency", currency:"ARS", maximumFractionDigits:0 }).format(n);
const pct         = (a,b) => b===0 ? "0%" : `${Math.round(a/b*100)}%`;
const toFirstName = str => { const w=str.split(" ")[0]; return w.charAt(0)+w.slice(1).toLowerCase(); };
const priority    = p => p>=500000?{label:"ALTA",color:"#22c55e"}:p>=100000?{label:"MEDIA",color:"#f59e0b"}:{label:"BAJA",color:"#64748b"};
const ckey        = (ck,n) => `${ck}:${n}`;
const lsGet = (key, fallback) => { try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch { return fallback; } };
const lsSet = (key, val)     => { try { localStorage.setItem(key, JSON.stringify(val)); } catch {} };

const MSGS = {
  hogar_auto: n=>`Hola ${toFirstName(n)}! 😊 ¿Cómo estás?\n\nQueríamos contarte desde CN que, junto a Sancor, estamos brindando descuentos adicionales en el seguro de *Auto* 🚗 para quienes ya son clientes de otros ramos, como tu caso que ya tenés asegurado con nosotros tu *Hogar*.\n\nSi te interesa, nos lo comentás y armamos una propuesta en unos minutos!\n\nContás además con servicios de urgencia como auxilio mecánico, gestión de siniestros y mucho más.`,
  auto_hogar: n=>`Hola ${toFirstName(n)}! 😊 ¿Cómo estás?\n\nQueríamos contarte desde CN que, junto a Sancor, estamos brindando descuentos adicionales en el seguro de *Hogar* 🏠 para quienes ya son clientes de otros ramos, como tu caso que ya tenés asegurado con nosotros tu *Auto*.\n\nSi te interesa, nos lo comentás y armamos una propuesta en unos minutos!\n\nContás con servicios de urgencia como cerrajería, electricidad, plomería, entre otros.`,
  moto_hogar: n=>`Hola ${toFirstName(n)}! 😊 ¿Cómo estás?\n\nQueríamos contarte desde CN que, junto a Sancor, estamos brindando descuentos adicionales en el seguro de *Hogar* 🏠 para quienes ya son clientes de otros ramos, como tu caso que ya tenés asegurado con nosotros tu *Moto*.\n\nSi te interesa, nos lo comentás y armamos una propuesta en unos minutos!\n\nContás con servicios de urgencia como cerrajería, electricidad, plomería, entre otros.`,
};

const CARTERAS = {
  peretti:{ key:"peretti", label:"ORG PERETTI", accentColor:"#3b82f6", tabs:[
    {key:"hogar",label:"🏠 Hogar → Auto",data:HOGAR_SIN_AUTO_PERETTI,tipo:"hogar_auto",color:"#3b82f6"},
    {key:"auto", label:"🚗 Auto → Hogar", data:AUTO_SIN_HOGAR_PERETTI, tipo:"auto_hogar", color:"#f59e0b"},
    {key:"moto", label:"🛵 Moto → Hogar", data:MOTO_SIN_HOGAR_PERETTI, tipo:"moto_hogar", color:"#8b5cf6"},
  ]},
  puerta:{ key:"puerta", label:"CN PUERTA", accentColor:"#ec4899", tabs:[
    {key:"hogar",label:"🏠 Hogar → Auto",data:HOGAR_SIN_AUTO_PUERTA,tipo:"hogar_auto",color:"#3b82f6"},
    {key:"auto", label:"🚗 Auto → Hogar", data:AUTO_SIN_HOGAR_PUERTA, tipo:"auto_hogar", color:"#f59e0b"},
    {key:"moto", label:"🛵 Moto → Hogar", data:MOTO_SIN_HOGAR_PUERTA, tipo:"moto_hogar", color:"#8b5cf6"},
  ]},
};

const ESTADO_OPTS = [
  {val:"exitoso",   label:"✅ Exitoso",   activeBg:"#14532d",activeColor:"#22c55e"},
  {val:"espera",    label:"⏳ En espera", activeBg:"#451a03",activeColor:"#f59e0b"},
  {val:"no_quiere", label:"❌ No quiere", activeBg:"#4c0519",activeColor:"#f43f5e"},
];

const C = {contactado:"#64748b",contesto:"#38bdf8",exitoso:"#22c55e",espera:"#f59e0b",no_quiere:"#f43f5e"};

const CustomTooltip = ({active,payload,label}) => {
  if (!active||!payload?.length) return null;
  return (
    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:8,padding:"10px 14px",fontSize:12}}>
      <div style={{color:"#94a3b8",fontWeight:700,marginBottom:6}}>{label}</div>
      {payload.map(p=><div key={p.name} style={{color:p.fill,marginBottom:2}}>{p.name}: <strong>{p.value}</strong></div>)}
    </div>
  );
};

// ─── LOGIN SCREEN ──────────────────────────────────────────────────────────
function LoginScreen({onUnlock}) {
  const [user, setUser]   = useState("");
  const [pw, setPw]       = useState("");
  const [error, setError] = useState(false);

  function tryLogin() {
    if (user.trim() === ACCESS_USER && pw.trim() === ACCESS_PASS) {
      onUnlock();
    } else {
      setError(true);
      setPw("");
      setTimeout(() => setError(false), 2000);
    }
  }

  return (
    <div style={{fontFamily:"'DM Sans','Segoe UI',sans-serif",background:"#0f172a",
      minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"#1e293b",border:"1px solid #1e3a5f",borderRadius:16,
        padding:"40px 36px",width:340,boxShadow:"0 25px 60px #000a",textAlign:"center"}}>
        <div style={{fontSize:36,marginBottom:12}}>🔒</div>
        <div style={{fontSize:11,letterSpacing:3,color:"#3b82f6",fontWeight:700,
          textTransform:"uppercase",marginBottom:6}}>CN ASESORES · Uso interno</div>
        <h2 style={{margin:"0 0 6px",fontSize:18,fontWeight:800,color:"#f1f5f9"}}>Cross-Selling Sancor</h2>
        <p style={{fontSize:12,color:"#475569",marginBottom:28}}>Ingresá tus credenciales para acceder</p>
        <div style={{display:"flex",flexDirection:"column",gap:10}}>
          <input
            type="text"
            placeholder="Usuario"
            value={user}
            onChange={e => setUser(e.target.value)}
            onKeyDown={e => e.key === "Enter" && tryLogin()}
            autoFocus
            style={{background:"#0f172a",border:`1px solid ${error?"#f43f5e":"#334155"}`,
              borderRadius:8,padding:"10px 14px",color:"#e2e8f0",fontSize:14,
              outline:"none",textAlign:"center",transition:"border-color .2s"}}
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={pw}
            onChange={e => setPw(e.target.value)}
            onKeyDown={e => e.key === "Enter" && tryLogin()}
            style={{background:"#0f172a",border:`1px solid ${error?"#f43f5e":"#334155"}`,
              borderRadius:8,padding:"10px 14px",color:"#e2e8f0",fontSize:14,
              outline:"none",textAlign:"center",letterSpacing:2,transition:"border-color .2s"}}
          />
          {error && <div style={{fontSize:12,color:"#f43f5e",fontWeight:600}}>Usuario o contraseña incorrectos</div>}
          <button onClick={tryLogin}
            style={{background:"#3b82f6",color:"#fff",border:"none",borderRadius:8,
              padding:"11px 0",fontWeight:700,fontSize:14,cursor:"pointer",marginTop:4}}>
            Ingresar
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── MAIN APP ──────────────────────────────────────────────────────────────
export default function App() {
  const [unlocked, setUnlocked]         = useState(false);
  const [view, setView]                 = useState("list");
  const [carteraKey, setCarteraKey]     = useState("peretti");
  const [tab, setTab]                   = useState("hogar");
  const [minPrima, setMinPrima]         = useState(0);
  const [search, setSearch]             = useState("");
  const [filterEstado, setFilterEstado] = useState(null);
  const [copied, setCopied]             = useState(null);
  const [contacted, setContacted]       = useState({});
  const [obs, setObs]                   = useState({});
  const [estados, setEstados]           = useState({});
  const [respuestas, setRespuestas]     = useState({});
  const [msgTarget, setMsgTarget]       = useState(null);
  const [dashFilter, setDashFilter]     = useState("all");

  const cartera   = CARTERAS[carteraKey];
  const activeTab = cartera.tabs.find(t=>t.key===tab);

  const filtered = useMemo(()=>{
    let data = activeTab.data.filter(c=>
      c.prima>=minPrima && c.nombre.toLowerCase().includes(search.toLowerCase())
    );
    if      (filterEstado==="contesto")    data=data.filter(c=> !!respuestas[ckey(carteraKey,c.nombre)]);
    else if (filterEstado==="no_contesto") data=data.filter(c=> !respuestas[ckey(carteraKey,c.nombre)]);
    else if (filterEstado)                 data=data.filter(c=> estados[ckey(carteraKey,c.nombre)]===filterEstado);
    return data;
  },[carteraKey,tab,minPrima,search,activeTab,filterEstado,respuestas,estados]);

  const kpis = useMemo(()=>{
    const data=activeTab.data;
    return {
      contactados: data.filter(c=>contacted[ckey(carteraKey,c.nombre)]).length,
      contestaron: data.filter(c=>respuestas[ckey(carteraKey,c.nombre)]).length,
      exitosos:    data.filter(c=>estados[ckey(carteraKey,c.nombre)]==="exitoso").length,
      espera:      data.filter(c=>estados[ckey(carteraKey,c.nombre)]==="espera").length,
      no_quiere:   data.filter(c=>estados[ckey(carteraKey,c.nombre)]==="no_quiere").length,
    };
  },[activeTab,carteraKey,contacted,respuestas,estados]);

  const dashData = useMemo(()=>{
    const cartKeys=dashFilter==="all"?["peretti","puerta"]:[dashFilter];
    const ramos=[{key:"hogar",label:"🏠 Hogar"},{key:"auto",label:"🚗 Auto"},{key:"moto",label:"🛵 Moto"}];
    const byRamo=ramos.map(r=>{
      let total=0,contactados=0,contestaron=0,exitosos=0,espera=0,no_quiere=0;
      cartKeys.forEach(ck2=>{
        CARTERAS[ck2].tabs.find(t=>t.key===r.key).data.forEach(c=>{
          total++;
          if(contacted[ckey(ck2,c.nombre)])  contactados++;
          if(respuestas[ckey(ck2,c.nombre)]) contestaron++;
          const e=estados[ckey(ck2,c.nombre)];
          if(e==="exitoso")   exitosos++;
          if(e==="espera")    espera++;
          if(e==="no_quiere") no_quiere++;
        });
      });
      return {name:r.label,total,contactados,contestaron,exitosos,espera,no_quiere};
    });
    const byCartera=Object.values(CARTERAS).map(c=>{
      let total=0,contactados=0,contestaron=0,exitosos=0,espera=0,no_quiere=0;
      c.tabs.forEach(t=>t.data.forEach(cl=>{
        total++;
        if(contacted[ckey(c.key,cl.nombre)])  contactados++;
        if(respuestas[ckey(c.key,cl.nombre)]) contestaron++;
        const e=estados[ckey(c.key,cl.nombre)];
        if(e==="exitoso")   exitosos++;
        if(e==="espera")    espera++;
        if(e==="no_quiere") no_quiere++;
      }));
      return {name:c.label,total,contactados,contestaron,exitosos,espera,no_quiere,color:c.accentColor};
    });
    const totals=byRamo.reduce((acc,r)=>({
      total:acc.total+r.total,contactados:acc.contactados+r.contactados,
      contestaron:acc.contestaron+r.contestaron,exitosos:acc.exitosos+r.exitosos,
      espera:acc.espera+r.espera,no_quiere:acc.no_quiere+r.no_quiere,
    }),{total:0,contactados:0,contestaron:0,exitosos:0,espera:0,no_quiere:0});
    const pieData=[
      {name:"Sin contactar",        value:Math.max(totals.total-totals.contactados,0),           fill:"#1e3a5f"},
      {name:"Contact. s/respuesta", value:Math.max(totals.contactados-totals.contestaron,0),     fill:C.contactado},
      {name:"Contest. s/estado",    value:Math.max(totals.contestaron-totals.exitosos-totals.espera-totals.no_quiere,0), fill:C.contesto},
      {name:"Exitosos",             value:totals.exitosos,   fill:C.exitoso},
      {name:"En espera",            value:totals.espera,     fill:C.espera},
      {name:"No quiere",            value:totals.no_quiere,  fill:C.no_quiere},
    ].filter(d=>d.value>0);
    return {byRamo,byCartera,totals,pieData};
  },[contacted,respuestas,estados,dashFilter]);

  useEffect(()=>lsSet('cn_contacted', contacted),[contacted]);
  useEffect(()=>lsSet('cn_obs',       obs),       [obs]);
  useEffect(()=>lsSet('cn_estados',   estados),   [estados]);
  useEffect(()=>lsSet('cn_respuestas',respuestas),[respuestas]);

  // ── early return DESPUÉS de todos los hooks ────────────────────────────
  if (!unlocked) return <LoginScreen onUnlock={()=>setUnlocked(true)} />;

  function copyMsg(n,tipo){ navigator.clipboard.writeText(MSGS[tipo](n)); setCopied(n); setTimeout(()=>setCopied(null),2000); }
  function toggleContacted(ck2,n){ setContacted(p=>({...p,[ckey(ck2,n)]:!p[ckey(ck2,n)]})); }
  function toggleRespuesta(ck2,n){ setRespuestas(p=>({...p,[ckey(ck2,n)]:!p[ckey(ck2,n)]})); }
  function setEstado(ck2,n,val)  { setEstados(p=>({...p,[ckey(ck2,n)]:p[ckey(ck2,n)]===val?null:val})); }
  function switchCartera(k)      { setCarteraKey(k);setTab("hogar");setSearch("");setMinPrima(0);setFilterEstado(null); }
  function switchTab(k)          { setTab(k);setSearch("");setMinPrima(0);setFilterEstado(null); }
  function toggleFE(fk)          { setFilterEstado(prev=>prev===fk?null:fk); }

  const btnSt=(active,bg,color,border)=>({
    background:active?bg:"#0f172a",color:active?color:"#475569",
    border:`1px solid ${active?border:"#1e293b"}`,
    borderRadius:5,padding:"3px 9px",fontSize:11,fontWeight:700,cursor:"pointer",transition:"all .15s",
  });

  const kpiChips=[
    {label:"Contactados",val:kpis.contactados,color:C.contactado,fk:null},
    {label:"Contestaron",val:kpis.contestaron,color:C.contesto,  fk:"contesto"},
    {label:"✅ Exitosos", val:kpis.exitosos,  color:C.exitoso,   fk:"exitoso"},
    {label:"⏳ Espera",   val:kpis.espera,    color:C.espera,    fk:"espera"},
    {label:"❌ No quiere",val:kpis.no_quiere, color:C.no_quiere, fk:"no_quiere"},
  ];

  return (
    <div style={{fontFamily:"'DM Sans','Segoe UI',sans-serif",background:"#0f172a",minHeight:"100vh",color:"#e2e8f0"}}>

      {/* HEADER */}
      <div style={{background:"linear-gradient(135deg,#1e293b,#0f172a)",borderBottom:"1px solid #1e3a5f",padding:"16px 24px 14px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
          <div>
            <div style={{fontSize:10,letterSpacing:3,color:view==="dashboard"?"#a855f7":cartera.accentColor,fontWeight:700,textTransform:"uppercase",marginBottom:3}}>
              CN ASESORES · Sancor · 27/05/2026
            </div>
            <h1 style={{margin:0,fontSize:19,fontWeight:800,color:"#f1f5f9"}}>Oportunidades de Cross-Selling</h1>
          </div>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {Object.values(CARTERAS).map(c=>(
              <button key={c.key} onClick={()=>{setView("list");switchCartera(c.key);}}
                style={{background:view==="list"&&carteraKey===c.key?c.accentColor:"#1e293b",
                  color:view==="list"&&carteraKey===c.key?"#fff":"#64748b",
                  border:`1px solid ${c.accentColor}66`,borderRadius:8,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                {c.label}
              </button>
            ))}
            <button onClick={()=>setView("dashboard")}
              style={{background:view==="dashboard"?"#7c3aed":"#1e293b",color:view==="dashboard"?"#fff":"#64748b",
                border:"1px solid #7c3aed66",borderRadius:8,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
              📊 Dashboard
            </button>
          </div>
        </div>
        {view==="list"&&(
          <div style={{display:"flex",gap:8,marginTop:12}}>
            {cartera.tabs.map(t=>(
              <div key={t.key} style={{background:"#0f172a",border:`1px solid ${t.color}44`,borderRadius:9,padding:"6px 14px",textAlign:"center"}}>
                <div style={{fontSize:20,fontWeight:900,color:t.color}}>{t.data.length}</div>
                <div style={{fontSize:9,color:"#64748b",fontWeight:600}}>
                  {t.key==="hogar"?"Hogar sin Auto":t.key==="auto"?"Auto sin Hogar":"Moto sin Hogar"}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* DASHBOARD */}
      {view==="dashboard"&&(
        <div style={{padding:"20px 24px"}}>
          <div style={{display:"flex",gap:6,marginBottom:20}}>
            {[{key:"all",label:"Todas"},{key:"peretti",label:"ORG Peretti"},{key:"puerta",label:"CN Puerta"}].map(f=>(
              <button key={f.key} onClick={()=>setDashFilter(f.key)}
                style={{background:dashFilter===f.key?"#7c3aed":"#1e293b",color:dashFilter===f.key?"#fff":"#64748b",
                  border:"1px solid #7c3aed55",borderRadius:7,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer"}}>
                {f.label}
              </button>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:10,marginBottom:24}}>
            {[
              {label:"Total clientes", val:dashData.totals.total,      color:"#7c3aed",sub:""},
              {label:"Contactados",    val:dashData.totals.contactados, color:C.contactado,sub:pct(dashData.totals.contactados,dashData.totals.total)},
              {label:"Contestaron",    val:dashData.totals.contestaron, color:C.contesto,  sub:pct(dashData.totals.contestaron,dashData.totals.contactados)+" de contact."},
              {label:"✅ Exitosos",    val:dashData.totals.exitosos,    color:C.exitoso,   sub:pct(dashData.totals.exitosos,dashData.totals.contactados)+" de contact."},
              {label:"⏳ En espera",   val:dashData.totals.espera,      color:C.espera,    sub:""},
              {label:"❌ No quiere",   val:dashData.totals.no_quiere,   color:C.no_quiere, sub:""},
              {label:"Conversión",     val:pct(dashData.totals.exitosos,dashData.totals.contactados),color:C.exitoso,sub:"exitosos/contactados",isText:true},
            ].map(k=>(
              <div key={k.label} style={{background:"#1e293b",border:`1px solid ${k.color}33`,borderRadius:10,padding:"14px 16px"}}>
                <div style={{fontSize:k.isText?22:28,fontWeight:900,color:k.color}}>{k.val}</div>
                <div style={{fontSize:11,color:"#94a3b8",fontWeight:600,marginTop:2}}>{k.label}</div>
                {k.sub&&<div style={{fontSize:10,color:"#475569",marginTop:2}}>{k.sub}</div>}
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
            {[{title:"Gestión por ramo",data:dashData.byRamo},{title:"Comparación por cartera",data:dashData.byCartera}].map(chart=>(
              <div key={chart.title} style={{background:"#1e293b",borderRadius:12,padding:"18px 16px"}}>
                <div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:14,letterSpacing:1,textTransform:"uppercase"}}>{chart.title}</div>
                <ResponsiveContainer width="100%" height={220}>
                  <BarChart data={chart.data} barCategoryGap="30%" barGap={2}>
                    <XAxis dataKey="name" tick={{fill:"#64748b",fontSize:11}} axisLine={false} tickLine={false}/>
                    <YAxis tick={{fill:"#334155",fontSize:10}} axisLine={false} tickLine={false}/>
                    <Tooltip content={<CustomTooltip/>} cursor={{fill:"#ffffff08"}}/>
                    <Legend wrapperStyle={{fontSize:11,color:"#64748b"}}/>
                    <Bar dataKey="contactados" name="Contactados" fill={C.contactado} radius={[3,3,0,0]}/>
                    <Bar dataKey="contestaron" name="Contestaron"  fill={C.contesto}   radius={[3,3,0,0]}/>
                    <Bar dataKey="exitosos"    name="Exitosos"     fill={C.exitoso}    radius={[3,3,0,0]}/>
                    <Bar dataKey="espera"      name="En espera"    fill={C.espera}     radius={[3,3,0,0]}/>
                    <Bar dataKey="no_quiere"   name="No quiere"    fill={C.no_quiere}  radius={[3,3,0,0]}/>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            <div style={{background:"#1e293b",borderRadius:12,padding:"18px 16px"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:8,letterSpacing:1,textTransform:"uppercase"}}>Embudo de conversión</div>
              {dashData.totals.contactados===0
                ?<div style={{color:"#334155",fontSize:13,textAlign:"center",paddingTop:60}}>Aún no hay datos de gestión</div>
                :<div style={{display:"flex",alignItems:"center"}}>
                  <ResponsiveContainer width="60%" height={200}>
                    <PieChart>
                      <Pie data={dashData.pieData} dataKey="value" cx="50%" cy="50%" outerRadius={80} strokeWidth={0}>
                        {dashData.pieData.map((e,i)=><Cell key={i} fill={e.fill}/>)}
                      </Pie>
                      <Tooltip contentStyle={{background:"#1e293b",border:"1px solid #334155",borderRadius:8,fontSize:11}}/>
                    </PieChart>
                  </ResponsiveContainer>
                  <div style={{flex:1}}>
                    {dashData.pieData.map(d=>(
                      <div key={d.name} style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
                        <div style={{width:10,height:10,borderRadius:2,background:d.fill,flexShrink:0}}/>
                        <span style={{fontSize:11,color:"#64748b"}}>{d.name}</span>
                        <span style={{fontSize:12,fontWeight:700,color:"#e2e8f0",marginLeft:"auto"}}>{d.value}</span>
                      </div>
                    ))}
                  </div>
                </div>
              }
            </div>
            <div style={{background:"#1e293b",borderRadius:12,padding:"18px 16px",overflowX:"auto"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#94a3b8",marginBottom:12,letterSpacing:1,textTransform:"uppercase"}}>Resumen por ramo</div>
              <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
                <thead>
                  <tr style={{color:"#475569"}}>
                    {["Ramo","Total","Contact.","Contest.","Exitosos","Espera","No quiere","Conv."].map(h=>(
                      <th key={h} style={{textAlign:h==="Ramo"?"left":"center",paddingBottom:8,fontWeight:600}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {dashData.byRamo.map(r=>(
                    <tr key={r.name} style={{borderTop:"1px solid #0f172a"}}>
                      <td style={{padding:"7px 0",color:"#cbd5e1",fontWeight:700}}>{r.name}</td>
                      <td style={{textAlign:"center",color:"#64748b"}}>{r.total}</td>
                      <td style={{textAlign:"center",color:C.contactado}}>{r.contactados}</td>
                      <td style={{textAlign:"center",color:C.contesto}}>{r.contestaron}</td>
                      <td style={{textAlign:"center",color:C.exitoso,fontWeight:700}}>{r.exitosos}</td>
                      <td style={{textAlign:"center",color:C.espera}}>{r.espera}</td>
                      <td style={{textAlign:"center",color:C.no_quiere}}>{r.no_quiere}</td>
                      <td style={{textAlign:"center",color:C.exitoso,fontWeight:700}}>{pct(r.exitosos,r.contactados)}</td>
                    </tr>
                  ))}
                  <tr style={{borderTop:"2px solid #334155"}}>
                    <td style={{padding:"8px 0",color:"#f1f5f9",fontWeight:800}}>TOTAL</td>
                    <td style={{textAlign:"center",color:"#f1f5f9",fontWeight:800}}>{dashData.totals.total}</td>
                    <td style={{textAlign:"center",color:C.contactado,fontWeight:800}}>{dashData.totals.contactados}</td>
                    <td style={{textAlign:"center",color:C.contesto,  fontWeight:800}}>{dashData.totals.contestaron}</td>
                    <td style={{textAlign:"center",color:C.exitoso,   fontWeight:800}}>{dashData.totals.exitosos}</td>
                    <td style={{textAlign:"center",color:C.espera,    fontWeight:800}}>{dashData.totals.espera}</td>
                    <td style={{textAlign:"center",color:C.no_quiere, fontWeight:800}}>{dashData.totals.no_quiere}</td>
                    <td style={{textAlign:"center",color:C.exitoso,   fontWeight:800}}>{pct(dashData.totals.exitosos,dashData.totals.contactados)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* LIST VIEW */}
      {view==="list"&&(
        <>
          <div style={{display:"flex",gap:3,padding:"12px 24px 0"}}>
            {cartera.tabs.map(t=>(
              <button key={t.key} onClick={()=>switchTab(t.key)}
                style={{background:tab===t.key?t.color:"#1e293b",color:tab===t.key?"#fff":"#94a3b8",
                  border:"none",borderRadius:"8px 8px 0 0",padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                {t.label} <span style={{opacity:.7,fontSize:11}}>({t.data.length})</span>
              </button>
            ))}
          </div>

          <div style={{background:"#1e293b",borderTop:`3px solid ${activeTab.color}`,padding:"12px 24px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <input placeholder="🔍 Buscar cliente..." value={search} onChange={e=>setSearch(e.target.value)}
              style={{background:"#0f172a",border:"1px solid #334155",borderRadius:7,padding:"7px 12px",color:"#e2e8f0",fontSize:13,width:200}}/>
            <div style={{display:"flex",alignItems:"center",gap:6}}>
              <span style={{fontSize:11,color:"#64748b"}}>Prima mín.</span>
              <select value={minPrima} onChange={e=>setMinPrima(Number(e.target.value))}
                style={{background:"#0f172a",border:"1px solid #334155",borderRadius:7,padding:"7px 10px",color:"#e2e8f0",fontSize:13}}>
                <option value={0}>Sin filtro</option>
                <option value={50000}>$50.000+</option>
                <option value={100000}>$100.000+</option>
                <option value={300000}>$300.000+</option>
                <option value={500000}>$500.000+</option>
                <option value={1000000}>$1.000.000+</option>
              </select>
            </div>
            <div style={{marginLeft:"auto",display:"flex",gap:6,flexWrap:"wrap",alignItems:"center"}}>
              {kpiChips.map(k=>{
                const isActive=k.fk!==null&&filterEstado===k.fk;
                return (
                  <button key={k.label} onClick={()=>k.fk&&toggleFE(k.fk)}
                    title={k.fk?(isActive?"Quitar filtro":`Filtrar: ${k.label}`):""}
                    style={{background:isActive?k.color+"22":"#0f172a",
                      border:`1px solid ${isActive?k.color:k.color+"33"}`,
                      borderRadius:7,padding:"3px 9px",outline:"none",
                      cursor:k.fk?"pointer":"default",
                      boxShadow:isActive?`0 0 0 1px ${k.color}44`:"none",transition:"all .15s"}}>
                    <span style={{fontSize:15,fontWeight:800,color:k.color}}>{k.val}</span>
                    <span style={{fontSize:10,color:isActive?k.color:"#475569",marginLeft:5,fontWeight:isActive?700:400}}>
                      {k.label}{isActive?" ✕":""}
                    </span>
                  </button>
                );
              })}
              {filterEstado&&(
                <button onClick={()=>setFilterEstado(null)}
                  style={{background:"#1e293b",border:"1px solid #334155",borderRadius:7,
                    padding:"3px 9px",cursor:"pointer",fontSize:11,color:"#64748b",outline:"none"}}>
                  Limpiar
                </button>
              )}
              <span style={{fontSize:11,color:"#475569"}}>
                <span style={{color:"#e2e8f0",fontWeight:700}}>{filtered.length}</span>
                {filterEstado&&<span style={{color:"#64748b"}}> filtrados</span>}
                {" · "}
                <span style={{color:activeTab.color,fontWeight:700}}>{fmt(filtered.reduce((a,c)=>a+c.prima,0))}</span>
              </span>
            </div>
          </div>

          <div style={{padding:"14px 24px",display:"flex",flexDirection:"column",gap:8}}>
            {filtered.length===0&&(
              <div style={{textAlign:"center",color:"#475569",padding:40}}>
                {filterEstado?"No hay clientes con ese estado aún.":"Sin resultados."}
              </div>
            )}
            {filtered.map((c,i)=>{
              const isContacted  = !!contacted[ckey(carteraKey,c.nombre)];
              const isCopied     = copied===c.nombre;
              const prio         = priority(c.prima);
              const estadoActual = estados[ckey(carteraKey,c.nombre)];
              const contesto     = !!respuestas[ckey(carteraKey,c.nombre)];
              return (
                <div key={c.nombre+i} style={{
                  background:isContacted?"#0f2a1a":"#1e293b",
                  border:`1px solid ${isContacted?"#166534":"#334155"}`,
                  borderLeft:`4px solid ${isContacted?"#22c55e":prio.color}`,
                  borderRadius:9,padding:"11px 14px",
                  display:"flex",flexDirection:"column",gap:8,
                  opacity:isContacted?0.6:1,transition:"all .2s",
                }}>
                  <div style={{display:"flex",alignItems:"center",gap:10}}>
                    <div style={{fontSize:11,color:"#475569",fontWeight:700,width:22,textAlign:"center",flexShrink:0}}>{i+1}</div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontWeight:700,fontSize:13,color:isContacted?"#4ade80":"#f1f5f9",
                        textDecoration:isContacted?"line-through":"none",
                        overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                        {c.nombre}
                      </div>
                      <div style={{fontSize:11,color:"#64748b",marginTop:1}}>
                        Prima: <strong style={{color:"#94a3b8"}}>{fmt(c.prima)}</strong>
                        {c.otros_ramos?.length>0&&<span style={{marginLeft:8}}>· también: {c.otros_ramos.join(", ")}</span>}
                      </div>
                    </div>
                    <div style={{background:prio.color+"22",color:prio.color,borderRadius:5,padding:"2px 7px",fontSize:10,fontWeight:800,letterSpacing:1,flexShrink:0}}>
                      {prio.label}
                    </div>
                    <button onClick={()=>setMsgTarget({...c,tipo:activeTab.tipo})}
                      style={{background:activeTab.color+"22",color:activeTab.color,border:`1px solid ${activeTab.color}44`,
                        borderRadius:6,padding:"5px 11px",fontSize:12,fontWeight:700,cursor:"pointer",whiteSpace:"nowrap"}}>
                      Ver msg
                    </button>
                    <button onClick={()=>copyMsg(c.nombre,activeTab.tipo)}
                      style={{background:isCopied?"#16a34a22":"#0f172a",color:isCopied?"#4ade80":"#64748b",
                        border:`1px solid ${isCopied?"#166534":"#334155"}`,
                        borderRadius:6,padding:"5px 10px",fontSize:12,cursor:"pointer",fontWeight:700,minWidth:74}}>
                      {isCopied?"✓ Listo":"📋 Copiar"}
                    </button>
                    <button onClick={()=>toggleContacted(carteraKey,c.nombre)}
                      style={{background:isContacted?"#166534":"transparent",color:isContacted?"#4ade80":"#334155",
                        border:`1px solid ${isContacted?"#166534":"#334155"}`,
                        borderRadius:6,padding:"5px 9px",fontSize:15,cursor:"pointer"}}>
                      {isContacted?"✓":"○"}
                    </button>
                  </div>
                  <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                    <button onClick={()=>toggleRespuesta(carteraKey,c.nombre)}
                      style={btnSt(contesto,"#0c4a6e","#38bdf8","#38bdf8")}>
                      {contesto?"📲 Contestó":"📵 No contestó"}
                    </button>
                    {ESTADO_OPTS.map(opt=>(
                      <button key={opt.val} onClick={()=>setEstado(carteraKey,c.nombre,opt.val)}
                        style={btnSt(estadoActual===opt.val,opt.activeBg,opt.activeColor,opt.activeColor)}>
                        {opt.label}
                      </button>
                    ))}
                  </div>
                  <textarea
                    placeholder="📝 Observaciones / respuesta del cliente..."
                    value={obs[ckey(carteraKey,c.nombre)]||""}
                    onChange={e=>setObs(p=>({...p,[ckey(carteraKey,c.nombre)]:e.target.value}))}
                    rows={1}
                    style={{background:"#0f172a",border:`1px solid ${obs[ckey(carteraKey,c.nombre)]?"#334155":"#1a2332"}`,
                      borderRadius:6,color:"#94a3b8",fontSize:12,padding:"6px 10px",
                      resize:"vertical",width:"100%",boxSizing:"border-box",fontFamily:"inherit",outline:"none",minHeight:30}}
                  />
                </div>
              );
            })}
          </div>
        </>
      )}

      {/* MODAL */}
      {msgTarget&&(
        <div style={{position:"fixed",inset:0,background:"#000000bb",display:"flex",alignItems:"center",justifyContent:"center",zIndex:100}}
          onClick={()=>setMsgTarget(null)}>
          <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:14,padding:24,maxWidth:460,width:"90%",boxShadow:"0 25px 60px #000a"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:10,color:"#64748b",letterSpacing:2,marginBottom:6,textTransform:"uppercase",fontWeight:700}}>Mensaje WhatsApp</div>
            <div style={{fontWeight:700,fontSize:14,color:"#f1f5f9",marginBottom:12}}>{msgTarget.nombre}</div>
            <div style={{background:"#0f172a",borderRadius:9,padding:14,fontSize:13,color:"#cbd5e1",
              lineHeight:1.65,whiteSpace:"pre-wrap",border:"1px solid #334155",maxHeight:280,overflowY:"auto"}}>
              {MSGS[msgTarget.tipo](msgTarget.nombre)}
            </div>
            <div style={{display:"flex",gap:8,marginTop:14}}>
              <button onClick={()=>{copyMsg(msgTarget.nombre,msgTarget.tipo);setMsgTarget(null);}}
                style={{flex:1,background:"#3b82f6",color:"#fff",border:"none",borderRadius:7,padding:"10px 0",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                📋 Copiar y cerrar
              </button>
              <button onClick={()=>setMsgTarget(null)}
                style={{background:"transparent",color:"#64748b",border:"1px solid #334155",borderRadius:7,padding:"10px 14px",cursor:"pointer",fontWeight:700}}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}

      <div style={{textAlign:"center",padding:16,fontSize:10,color:"#1e3a5f"}}>
        CN ASESORES · Sancor 27/05/2026 · Uso interno
      </div>
    </div>
  );
}
